import { Fragment } from 'react';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SmallGridRowIcons = ({ athlete, onDeleteClicked }) => (
  <Fragment>
    {athlete.canBeDeleted === true &&
      <button
        type='button'
        className={global.IconButton}
        onClick={() => onDeleteClicked(athlete)}>
        <DeleteIcon />
      </button>
    }
  </Fragment>
);

//TODO tablet view
const SmallGridRow = ({ athlete, onDeleteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}>
      <span></span>&nbsp;
      <SmallGridRowIcons
        athlete={athlete}
        onDeleteClicked={onDeleteClicked} />
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Full Name
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {athlete?.firstName || ''} {athlete?.middleName || ''} {athlete?.lastName || ''}
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Birth Date
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {athlete?.birthDate ? formatDate(athlete.birthDate) : ''}
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Member Id
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {athlete?.memberId}
        </div>
      </div>
    </div>
  </div>
);

const LaneSheetMeetEventAddParticipantsSmallGrid = ({ isLoading, gridData, onDeleteClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}><div className={global.SmallTableRowLabels}>Loading...</div></div>
        </div>
      ) : Array.isArray(gridData) && gridData?.length > 0
        ? gridData?.map((athlete, i) =>
          <SmallGridRow
            key={i}
            athlete={athlete}
            onDeleteClicked={onDeleteClicked} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}><div className={global.SmallTableRowLabels}>No Results</div></div>
          </div>
        )
    }
  </div>
);

export default LaneSheetMeetEventAddParticipantsSmallGrid;